/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import './auth.css';
import { auth } from '../services/FirestoreService'
import Account from './Account';
import { User } from 'firebase/auth';

interface LoginProps {
    showAccount: boolean,
    setShowAccount: (show: boolean) => void;
    onUserChanged: (userData: User | null) => void;
}

const Login: React.FC<LoginProps> = ({ showAccount, setShowAccount, onUserChanged }) => {

    const user = auth.currentUser;
    return (<>
        {showAccount && <Account onClose={() => setShowAccount(false)} onUserChanged={onUserChanged} />}
        <a href="#" style={{ color: '#8888FF' }} onClick={() => setShowAccount(true)}
            title={user ? 'view account information / logout' : 'Login / register'}>
            {user?.displayName || user?.email || 'login'}
        </a>
    </>);
};
export default Login;
